import { MOCK_THREADS_RAW, MOCK_THREAD_MESSAGES_RAW_BY_ID } from './mock/messages.mock'
import { normalizeThreadList, normalizeThreadMessages } from './messages.adapter'

const DEFAULT_DELAY = 300

function delayedResponse(resolver) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        resolve(resolver())
      } catch (error) {
        reject(error)
      }
    }, DEFAULT_DELAY)
  })
}

export function getThreads({ leadId, mode = 'success' } = {}) {
  return delayedResponse(() => {
    if (mode === 'error') {
      throw new Error('Failed to load threads')
    }

    if (mode === 'empty') {
      return []
    }

    const _leadId = leadId
    return normalizeThreadList(MOCK_THREADS_RAW).map(item => ({ ...item, leadId: _leadId }))
  })
}

export function getThreadMessages({ threadId, thread, mode = 'success' } = {}) {
  return delayedResponse(() => {
    if (mode === 'error') {
      throw new Error('Failed to load messages')
    }

    const rawMessages = MOCK_THREAD_MESSAGES_RAW_BY_ID[threadId] || []
    return normalizeThreadMessages(rawMessages, thread)
  })
}
